var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found"},[_c('center',[_c('h1',[_vm._v("404 not found")]),_c('h2',[_vm._v("it seems you're in the wrong page")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }